import { useEffect, useState } from 'react';
import { Eyebrow } from '@/components/ui';
import { useTaskStore } from '@/stores/taskStore';
import type { Task } from '@/types';

export interface NotesFieldProps {
  task: Task;
}

export function NotesField({ task }: NotesFieldProps) {
  const [local, setLocal] = useState(task.notes ?? '');
  const updateTask = useTaskStore((s) => s.updateTask);

  useEffect(() => {
    // Sync local state when the active task switches (task.id changes).
    // This is intentional prop-to-state sync for a controlled optimistic input.
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setLocal(task.notes ?? '');
  }, [task.id, task.notes]);

  useEffect(() => {
    if (local === (task.notes ?? '')) return;
    const id = setTimeout(() => updateTask(task.id, { notes: local }), 500);
    return () => clearTimeout(id);
  }, [local, task.id, task.notes, updateTask]);

  return (
    <div>
      <Eyebrow as="label" htmlFor="task-notes" className="mb-1">
        Notes
      </Eyebrow>
      <textarea
        id="task-notes"
        value={local}
        onChange={(e) => setLocal(e.target.value)}
        onBlur={() => {
          if (local !== (task.notes ?? '')) updateTask(task.id, { notes: local });
        }}
        placeholder="Notes…"
        rows={3}
        className="w-full rounded-md border border-line-2 bg-bg px-2.5 py-1.5 text-body text-t1 outline-none placeholder:text-t2 focus-visible:border-line-3 focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2 focus-visible:ring-offset-canvas"
      />
    </div>
  );
}
